import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import PropTypes from "prop-types";
import { Button, ButtonGroup } from "reactstrap";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
import { Spinner } from "reactstrap";
import "./index.css";
import Typography from "Components/CommonComponents/Typography";
import SearchWIcon from "Assets/Icons/SearchWIcon";
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

const options = {
  cMapUrl: "cmaps/",
  cMapPacked: true,
  standardFontDataUrl: "standard_fonts/",
};
function PDFPageviewer(props) {
  const { pdfUrl, allPageInOne, pdfPassword, isLibraryView } = props;
  // const [isFullScreen, setIsFullScreen] = useState(false);
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageloading, setPageloading] = useState(false);
  const [scale, setScale] = useState(1.1);
  const [password, setPassword] = useState(pdfPassword);
  const [pDFError, setPDFError] = useState(null);
  const onDocumentLoadSuccess = useCallback(
    ({ numPages }) => {
      setPDFError(null);
      setNumPages(numPages);
      setPageNumber(1);
    },
    [pdfUrl]
  );
  useEffect(() => {
    setPassword(pdfPassword);
  }, [pdfPassword]);
  // const toggleFullScreen = () => {
  //   if (!isFullScreen) {
  //     console.log("fullscreen", isFullScreen, document.documentElement);
  //     if (document.documentElement.requestFullscreen) {
  //       document.documentElement.requestFullscreen();
  //     } else if (document.documentElement.mozRequestFullScreen) {
  //       document.documentElement.mozRequestFullScreen();
  //     } else if (document.documentElement.webkitRequestFullscreen) {
  //       document.documentElement.webkitRequestFullscreen();
  //     } else if (document.documentElement.msRequestFullscreen) {
  //       document.documentElement.msRequestFullscreen();
  //     }
  //   } else {
  //     console.log("fullscreen", isFullScreen);
  //     if (document.exitFullscreen) {
  //       document.exitFullscreen();
  //     } else if (document.mozCancelFullScreen) {
  //       document.mozCancelFullScreen();
  //     } else if (document.webkitExitFullscreen) {
  //       document.webkitExitFullscreen();
  //     } else if (document.msExitFullscreen) {
  //       document.msExitFullscreen();
  //     }
  //   }
  //   setIsFullScreen(!isFullScreen);
  // };
  const changePage = (offset) => {
    setPageloading(true);
    setPageNumber((prevPageNumber) => prevPageNumber + offset);
  };

  const previousPage = () => {
    changePage(-1);
  };

  const nextPage = () => {
    changePage(1);
  };
  const file = useMemo(
    () => ({
      url: pdfUrl,
    }),
    [pdfUrl]
  );
  const handleScale = (type) => {
    if (type == "reset") {
      setScale(1.1);
    } else if (type == "plus") {
      setScale(Number(scale) + 0.1);
    } else {
      setScale(Number(scale) - 0.1);
    }
  };
  const renderDocument = () => {
    return (
      <>
        <Document
          className={`pdf-document-viewer ${!pageloading ? "pdf-loaded" : ""}`}
          file={file}
          onPassword={(callback) => callback(password)}
          onContextMenu={(e) => e.preventDefault()}
          loading={
            <div className="pdfLoadingContainer">
              <Spinner color="info" />
            </div>
          }
          externalLinkRel="_blank"
          externalLinkTarget="_blank"
          error={
            <div className="pdfErrorContainer">Failed to load PDF file.!</div>
          }
          onLoadError={(error) => {
            setPDFError(error);
          }}
          options={options}
          onLoadSuccess={onDocumentLoadSuccess}
        >
          {allPageInOne ? (
            Array.from(new Array(numPages), (el, index) => (
              <Page
                scale={scale}
                width={1000}
                renderAnnotationLayer={true}
                renderTextLayer={true}
                onGetAnnotationsSuccess={(annotations) => {
                  console.log(annotations, "annotations");
                }}
                onGetAnnotationsError={(error) =>
                  console.log("annotations! " + error.message)
                }
                loading={
                  <div className="pdfLoadingContainer">
                    <Spinner color="info" />
                  </div>
                }
                onRenderSuccess={() => {
                  setPageloading(false);
                }}
                externalLinkTarget="_blank"
                externalLinkRel="_blank"
                key={`page_${index + 1}`}
                pageNumber={index + 1}
              />
            ))
          ) : (
            <Page
              scale={scale}
              width={1000}
              canvasBackground={"white"}
              renderAnnotationLayer={true}
              renderTextLayer={true}
              onGetAnnotationsSuccess={(annotations) => {
                console.log(annotations, "annotations");
              }}
              onGetAnnotationsError={(error) =>
                console.error("annotations! " + error.message)
              }
              loading={
                <div className="pdfLoadingContainer">
                  <Spinner color="info" />
                </div>
              }
              onRenderSuccess={() => {
                setPageloading(false);
              }}
              externalLinkTarget="_blank"
              externalLinkRel="_blank"
              pageNumber={pageNumber}
            />
          )}
        </Document>
        {allPageInOne ? (
          <div
            className={
              isLibraryView
                ? "pdf-button-container-library"
                : "pdf-button-container"
            }
          >
            <div></div>
            <div>
              {pDFError == null ? (
                <ButtonGroup>
                  <Button
                    size="sm"
                    color="aeslPrimary"
                    onClick={() => handleScale("minus", -10)}
                  >
                    -
                  </Button>
                  <Button
                    size="sm"
                    color="aeslPrimary"
                    onClick={() => handleScale("reset", 0)}
                  >
                    <SearchWIcon />
                  </Button>
                  <Button
                    size="sm"
                    color="aeslPrimary"
                    onClick={() => handleScale("plus", +10)}
                  >
                    +
                  </Button>
                </ButtonGroup>
              ) : null}
            </div>
            <div></div>
          </div>
        ) : (
          <div className="px-3 d-flex flex-row justify-content-between align-items-center mt-2 w-100">
            <Typography variant="body3" color="black">
              Page {pageNumber || (numPages ? 1 : "--")} of {numPages || "--"}
            </Typography>
            <div>
              <ButtonGroup>
                <Button
                  size="sm"
                  color="aeslPrimary"
                  onClick={() => handleScale("minus", -10)}
                >
                  -
                </Button>
                <Button
                  size="sm"
                  color="aeslPrimary"
                  onClick={() => handleScale("reset", 0)}
                >
                  <SearchWIcon />
                </Button>
                <Button
                  size="sm"
                  color="aeslPrimary"
                  onClick={() => handleScale("plus", +10)}
                >
                  +
                </Button>
              </ButtonGroup>
            </div>
            <div>
              <Button
                size="sm"
                color="aeslPrimary"
                disabled={pageNumber <= 1}
                onClick={previousPage}
              >
                Previous
              </Button>
              <Button
                size="sm"
                color="aeslPrimary"
                disabled={pageNumber >= numPages}
                onClick={nextPage}
              >
                Next
              </Button>
            </div>
          </div>
        )}
      </>
    );
  };
  return <>{renderDocument()}</>;
}

PDFPageviewer.propTypes = {
  pdfUrl: PropTypes.string,
  allPageInOne: PropTypes.bool,
  pdfPassword: PropTypes.string,
  isFullScreen: PropTypes.bool,
  setIsFullScreen: PropTypes.func,
  isLibraryView: PropTypes.bool,
  source: PropTypes.string,
};
export default PDFPageviewer;
